<template>
    <div class="usage-counter">
        <span class="title">{{title}}</span>
        <div>
            <slot name="icon"></slot>
            <span v-if="!maxAmount">{{usageAmount}}</span>
            <span v-else :class="{'text-danger': danger}" class="counter">{{usageAmount}} / {{maxAmount}}</span>

            <!-- <div v-else :class="{'text-danger': danger}">
                <animate-text style="margin-right:2px;" :number="usageAmount" :animateTime="20"/>
                <span> / {{maxAmount}}</span>
            </div> -->
        </div>
    </div>
</template>

<script>
import AnimateText from '@/components/AnimateText'
export default {
name: 'SubscriptionOverview',
  data() {
    return {

    }
  },
  props:{
      title: String,
      usageAmount: Number,
      maxAmount: Number,
      dangerZone:{
          type: Number,
          default: 80
      }
  },
  methods:{

  },
  watch:{
      usageAmount: {
          handler: function(){
              console.log(this.usageAmount)
              console.log(this.usageAmount / this.maxAmount * 100)
              // if usageAmount is more than dangerzone of maxamount
          }
      }, immediate: true
  },
  computed:{
    danger(){
        return (this.usageAmount / this.maxAmount * 100) > this.dangerZone
    }
  },
  components: {
   AnimateText
  }

};
</script>

<style lang="less">
.usage-counter{
    .title{
        font-size: 14px;
        font-weight: bold;
    }
    span{
        font-weight: bold;
    }
    div{
        margin-top: 8px;
        display: flex;
        gap: 8px;
        // justify-content: flex-start;
        align-items: flex-end;
    }

}
</style>
